/**
 * When a conversation last had activity, as the design shows it: the clock time
 * today, the weekday within the last week, a date beyond that.
 *
 * Locale comes from the browser, as elsewhere in the app, and Intl supplies the
 * wording — so this needs no translation keys.
 */

const DAY_MS = 24 * 60 * 60 * 1000

/** Midnight local, so "yesterday" means the calendar day and not 24 hours. */
function startOfDay(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
}

export function conversationTimestamp(
  timestamp: number,
  now: number = Date.now()
): string {
  const date = new Date(timestamp)
  const daysApart = Math.round(
    (startOfDay(new Date(now)) - startOfDay(date)) / DAY_MS
  )

  // Negative means the future, which only a skewed clock produces. Reading it
  // as today beats printing next Tuesday.
  if (daysApart <= 0) {
    return date.toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit",
    })
  }

  if (daysApart < 7) {
    return date.toLocaleDateString(undefined, { weekday: "short" })
  }

  return date.toLocaleDateString(undefined, { day: "numeric", month: "short" })
}
